{
  "version": 1,
  "asset_id": "5d447a5e-7230-43c8-8169-7086611f6f56",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/5d447a5e-7230-43c8-8169-7086611f6f56/hiatal-type-3-v2-1536.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/5d447a5e-7230-43c8-8169-7086611f6f56/hiatal-type-3-v2-1536.jpg",
  "original_filename": "hiatal-type-3-v2-1536.jpg",
  "size": 227201,
  "content_type": "image/jpeg",
  "created_at": "2026-09-24T19:27:46Z"
}
